import { Component, OnInit, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { HrisIntegrationDataService } from '../../services/hris-integration-data.service';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { DialogService } from '../../../../../core/services/dialog.service';
import { TextButtonComponent } from '../../../../../shared/components/text-button/text-button.component';

@Component({
  selector: 'app-hris-integration-banner',
  imports: [TranslocoPipe, MatIcon, TextButtonComponent],
  templateUrl: './hris-integration-banner.component.html',
})
export class HrisIntegrationBannerComponent implements OnInit {
  protected readonly hrisIntegrationDataService = inject(
    HrisIntegrationDataService,
  );
  protected readonly router = inject(Router);
  private readonly dialogService = inject(DialogService);

  ngOnInit(): void {
    this.hrisIntegrationDataService.init();
  }

  get bgClass(): string {
    if (!this.hrisIntegrationDataService.hrisIntegration) {
      return '';
    }
    switch (this.hrisIntegrationDataService.hrisIntegration.status) {
      case 'active':
        return 'bg-success-light';
      case 'inactive':
        return 'bg-warning-light';
      case 'error':
        return 'bg-danger-light';
      default:
        return 'bg-grey-veryLightGrey';
    }
  }

  get statusClass(): string {
    if (!this.hrisIntegrationDataService.hrisIntegration) {
      return '';
    }
    switch (this.hrisIntegrationDataService.hrisIntegration.status) {
      case 'active':
        return 'text-success';
      case 'inactive':
        return 'text-warning';
      case 'error':
        return 'text-danger';
      default:
        return '';
    }
  }

  goToTeam(): void {
    this.dialogService.closeAll();
    void this.router.navigate(['/portal/team']);
  }
}
